<template>
  <BaseAutoComplete
    v-model="model"
    :options="users"
    v-bind="$attrs"
  />
</template>

<script lang="ts" setup>
import { find } from 'underscore'
import { computed, watch } from 'vue'
import UserService from '@/services/UserService'
import { useQuery } from '@tanstack/vue-query'
import BaseAutoComplete from './BaseAutoComplete.vue'
import { UserType } from '@/models/user'

const selectedUser = defineModel({
  type: String,
  default: ''
})

const emit = defineEmits(['change'])

const userService = new UserService()
const { data: users } = useQuery({
  queryKey: ['users'],
  queryFn: () => userService.find_by('type', '==',  UserType.EMPLOYEE).then((users) => {
    return  users.filter((user) => user.name).map((user) => ({ label: user.name, value: user.id, ...user }))
  })
})

const model = computed({
  get: () => {
    if (users.value) {
      return find(users.value, (user) => user.value === selectedUser.value)
    }
    return null
  },
  set: (value) => {
    selectedUser.value = value.value
  }
})

watch(model, () => {
  if (model.value) {
    selectedUser.value = model.value.value
  }
  emit('change', model.value)
})

</script>
